import config from 'src/config';
import { deleteRequest, getRequest, postRequest, putRequest } from 'src/utils/RequestUtil';

export const scheduleTaskSearchAPI = function (data) {
    const url = `${config.baseUrl}scheduleTask/search`;
    return postRequest({
        url,
        data,
    });
};
export const scheduleTaskCreateAPI = function (data) {
    const url = `${config.baseUrl}scheduleTask/save`;
    return postRequest({
        url,
        data,
    });
};

export const scheduleTaskUpdateAPI = function ({
    scheduleTaskId,
    data,
}) {
    const url = `${config.baseUrl}scheduleTask/update/${scheduleTaskId}`;
    return putRequest({
        url,
        data,
    });
};
export const scheduleSubTaskDeleteAPI = function ({
    scheduleSubTaskId,
}) {
    const url = `${config.baseUrl}scheduleTask/deleteSubTask/${scheduleSubTaskId}`;
    return deleteRequest({
        url,
    });
};
export const scheduleSubTaskReorderAPI = function (data) {
    const url = `${config.baseUrl}scheduleTask/save-task-hierarchy`;
    return postRequest({
        url,
        data
    });
};
export const scheduleSubTaskMarkCompleteAPI = function ({
    data,
}) {
    const url = `${config.baseUrl}scheduleTask/save-task-completion`;
    return postRequest({
        url,
        data
    });
};
export const scheduleSubTaskSkipAPI = function ({
    data,
}) {
    const url = `${config.baseUrl}scheduleTask/save-task-skip`;
    return postRequest({
        url,
        data
    });
};


export const getReportingManager = function (data) {
    const url = `${config.baseUrl}scheduleTask/getReportingManager`;
    return postRequest({
        url,
        data,
    });
};

export const invitationResend = function (data) {
    const url = `${config.baseUrl}scheduleTask/reSendInvitation`;
    return postRequest({
        url,
        data,
    });
};
export const getAssignedProjectFromAPI = function (scheduleTaskId) {
    const url = `${config.baseUrl}project/getAssignedProjects/${scheduleTaskId}`;
    return getRequest({
        url,
    });
};
export const getTaskByProjectFromAPI = function (projectId,scheduleTaskId) {
    const url = `${config.baseUrl}project/getTasksByProjectId/${projectId}/${scheduleTaskId}`;
    return getRequest({
        url,
    });
};
export const getModuleByTaskFromAPI = function (taskId) {
    const url = `${config.baseUrl}project/getModuleByTaskId/${taskId}`;
    return getRequest({
        url,
    });
};
export const getUserList = async (where = {}) => {
    const response = await postRequest({
      url: `${config.baseUrl}scheduleTask/get`,
      data: { where }
    })
    return response
  }
  export const getTaskListAPI = async () => {
    const response = await getRequest({
      url: `${config.baseUrl}scheduleTask/getTasks`,
    })
    return response
  }
  export const TaskUpsertAPI = async (data) => {
    const response = await postRequest({
      url: `${config.baseUrl}scheduleTask/task`,
      data
    })
    return response
  }